const { getOffsetTop } = window.BAO.Utils

class FullScreen extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    if (this.dataset.sticky === 'true') {
      this.setupSticky()
    }

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setContentVisibility()
  }

  setContentVisibility () {
    this.classList.toggle(
      'sec-FullScreenBanner-hideLink',
      !this.linkShouldBeVisible,
    )
    if (this.els?.title?.exists) {
      this.classList.toggle(
        'sec-FullScreenBanner-hideTitle',
        !this.titleShouldBeVisible,
      )
    }
  }

  get linkShouldBeVisible () {
    const triggerPosition = this.els?.link?.element
    if (!triggerPosition) return

    if (this.lastKnownY < getOffsetTop(triggerPosition) - 55) {
      return true
    } else {
      return false
    }
  }

  get titleShouldBeVisible () {
    const triggerPosition = this.els?.title?.element
    if (!triggerPosition) return

    if (this.lastKnownY < getOffsetTop(triggerPosition) - 55) {
      return true
    } else {
      return false
    }
  }

  setupSticky () {
    const containerOffset = getOffsetTop(this)
    const elementOffset = this.els?.title?.exists
      ? getOffsetTop(this.els.title.element)
      : 0

    this.style.setProperty(
      '--StickyOffset',
      `${elementOffset - containerOffset}px`,
    )
  }
}

if (!customElements.get('full-screen')) {
  customElements.define('full-screen', FullScreen)
}
